import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'timeAgo',
  pure: false,
  standalone: true
})
export class TimeAgoPipe implements PipeTransform {
  private transloco = inject(TranslocoService);

  transform(date: Date | null, nowMs: number = Date.now()): string {
    if (!date) {
      return '--';
    }

    const secondsAgo = Math.max(0, Math.floor((nowMs - new Date(date).getTime()) / 1000));

    if (secondsAgo < 60) {
      if (secondsAgo === 0) {
        return this.transloco.translate('COMMON.JUST_NOW');
      }
      return this.transloco.translate('COMMON.SEC_AGO', { count: secondsAgo });
    }

    const minutesAgo = Math.floor(secondsAgo / 60);
    const remainingSeconds = secondsAgo % 60;

    if (minutesAgo < 60) {
      if (remainingSeconds === 0) {
        if (minutesAgo === 1) {
          return this.transloco.translate('COMMON.MINUTE_AGO');
        }
        return this.transloco.translate('COMMON.MINUTES_AGO', { count: minutesAgo });
      }
      if (minutesAgo === 1) {
        return this.transloco.translate('COMMON.MINUTE_AND_SECS', { minutes: minutesAgo, seconds: remainingSeconds });
      }
      return this.transloco.translate('COMMON.MINUTES_AND_SECS', { minutes: minutesAgo, seconds: remainingSeconds });
    }

    const hoursAgo = Math.floor(minutesAgo / 60);
    if (hoursAgo < 24) {
      if (hoursAgo === 1) {
        return this.transloco.translate('COMMON.HOUR_AGO');
      }
      return this.transloco.translate('COMMON.HOURS_AGO', { count: hoursAgo });
    }

    const daysAgo = Math.floor(hoursAgo / 24);
    if (daysAgo === 1) {
      return this.transloco.translate('COMMON.DAY_AGO');
    }
    return this.transloco.translate('COMMON.DAYS_AGO', { count: daysAgo });
  }
}
